import { auth, db, setDocWithQueue } from './firebase';
import { doc } from 'firebase/firestore';
import { safeClone } from '../lib/utils';

export async function queueHealthSync(type: 'MEAL' | 'WATER', data: any, client_log_id: string) {
  try {
    const user = auth.currentUser;
    if (!user) return;

    // Fire and forget API call for frictionless background execution
    const token = await user.getIdToken();
    const clonedData = safeClone(data);
    
    // We intentionally don't await this to avoid UI freezes, but we catch errors for graceful degradation
    fetch('/api/health-sync/webhook', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`
      },
      body: JSON.stringify(safeClone({
        client_log_id,
        type,
        data: clonedData,
        timestamp: new Date().toISOString()
      }))
    }).then(res => {
        if (!res.ok) throw new Error('Sync failed');
    }).catch(err => {
      // Graceful Degradation: If API fails, cache pending payloads locally in Firestore
      console.warn("Health sync degraded, queuing locally:", err);
      const syncDocRef = doc(db, 'users', user.uid, 'offline_sync_queue', client_log_id);
      setDocWithQueue(syncDocRef, {
         type,
         data: clonedData,
         timestamp: new Date().toISOString(),
         client_log_id,
         status: 'PENDING'
      });
    });
  } catch (err) {
    console.error("Failed to initiate health sync", err);
  }
}
